"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendUpdateAudioSettingsMsg = exports.SEND_UPDATE_INSET_AUDIO_SETTINGS = exports.RESPOND_UPDATE_INSET_AUDIO_SETTINGS = void 0;
var _globalStates = require("../globalstates/globalStates");
var _messageModel = require("./messageModel");
var INSET = 3000;
var SEND_UPDATE_INSET_AUDIO_SETTINGS = exports.SEND_UPDATE_INSET_AUDIO_SETTINGS = new _messageModel.RequestMessageDefinition(INSET, 3);
var RESPOND_UPDATE_INSET_AUDIO_SETTINGS = exports.RESPOND_UPDATE_INSET_AUDIO_SETTINGS = new _messageModel.RespondMessageDefinition(INSET, 3);
var sendUpdateAudioSettingsMsg = exports.sendUpdateAudioSettingsMsg = function sendUpdateAudioSettingsMsg(audioSettings) {
  (0, _globalStates.getGlobalStates)().eventBus.sendMsg(SEND_UPDATE_INSET_AUDIO_SETTINGS, audioSettings);
};